import React from 'react';

import AppHeader from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import '../../../../Styles/Linkages&Outreach.css';
import AstronomyIntroduction from './AstronomyIntroduction';
import AstronomyInitiatives from './AstronomyInitiatives';

const banner = 'https://ncgsa.org.pk/wp-content/uploads/2025/07/Astronomy-Outreach.jpg';

const AstronomyOutreach = () => (
  <>
    <AppHeader />
    <main className="astronomy-outreach-page">
      <section className="outreach-event-hero" aria-label="Astronomy Outreach">
        <img
          className="outreach-event-banner"
          src={banner}
          alt="Astronomy Outreach"
        />
      </section>
      <AstronomyIntroduction />
      <AstronomyInitiatives />
    </main>
    <FooterComponent />
  </>
);

export default AstronomyOutreach;
